module.exports = __webpack_public_path__ + "static/media/signup-slider2.0a962d5f.png";